import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectCommunitiesListItems } from "../../../../../redux/community/selector";
import { communities } from "../../../../../redux/community/action";
import { selectListItems } from "../../../../../redux/library/selector";

const MyCommunities = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const libraryData = useSelector(selectListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const communitiesItems = useSelector(selectCommunitiesListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});

  const handleReloadData = () => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`, entity: 'communities', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchCommunities = () => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`, entity:
        'communities', jsonData: {
          "Context": {
            "Subscription": "ONE",
            "Domain": "ONE",
            "SubDomains": [],
            "Network": "Venture",
            "Application": "Venture",
            "Channel": "CSP"
          },
          "Records": [
            {
              "Id": 0
            }
          ],
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",

        }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];
  useEffect(() => {
    fetchCommunities()
  }, [pageData, pageSize])

  return (
    <>
      {communitiesItems?.isLoading ? (
        <PageLoader />
      ) : (
        <div className="max-w-7xl mx-auto px-4 py-6">
           <div className="flex justify-end mb-4 pr-7">
            {additionButtons.map((btn: any, index: number) => (
              <button
                key={index}
                onClick={btn.callback}
                className="p-2 border rounded-md bg-black text-white hover:bg-gray-800"
                title="Reload"
              >
                {btn.svg}
              </button>

            ))}
          </div>

          <div className="space-y-6">
            {communitiesItems?.result?.items?.map((item: any) => (
              <div
                key={item.Id}
                className="flex flex-col sm:flex-row items-start bg-indigo-50 border border-indigo-200 shadow rounded-2xl p-6 hover:shadow-md transition duration-200"
              >
                <img
                  src={item.LogoUrl || item.CoverImageUrl}
                  alt={item.Name}
                  className="w-32 h-32 rounded-lg object-cover mr-0 sm:mr-6 mb-4 sm:mb-0"
                />

                <div className="flex-1 space-y-2">
                  <button
                    onClick={() => handleEdit(item)}
                    className="text-2xl font-bold text-indigo-800 hover:underline"
                  >
                    {item.Name}
                  </button>

                  <p className="text-base text-gray-700">{item.Description}</p>

                  <div className="text-sm text-gray-600 mt-2 flex flex-wrap gap-x-10 gap-y-2">
                    <span>
                      <strong>Status:</strong>{' '}
                      {
                        libraryData?.result?.CommunityStatus?.find(
                          (status: any) => status.Value === item.CommunityStatusId
                        )?.Text || '-'
                      }
                    </span>
                    <span>
                      <strong>Training:</strong>{' '}
                      {item.IsTrainingAvailable ? 'Yes' : 'No'}
                    </span>
                    <span>
                      <strong>Members:</strong> {item.MembersCount}
                    </span>
                    <span>
                      <strong>Events:</strong> {item.EventsCount}
                    </span>
                    <span>
                      <strong>Forums:</strong> {item.ForumGroupsCount}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );

};

export default MyCommunities;